import { Component, computed, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'name-initials',
  standalone: true,
  imports: [NgClass],
  templateUrl: './name-initials.component.html'
})
export class NameInitialsComponent {
  data = input.required<string>();
  size = input<'small' | 'medium' | 'large'>('medium');

  sizeClass = computed(() => {
    if (this.size() === 'small') {
      return 'user-24';
    } else if (this.size() === 'medium') {
      return 'user-30';
    } else {
      return 'user-38';
    }
  });

  array = computed(() => this.data().split(' '));

  firstWord = computed(() => (this.array().length > 0 ? this.array()[0].charAt(0).toUpperCase() : ''));
  secondWord = computed(() => {
    const arrayLength = this.array().length;
    if (arrayLength == 1) {
      return this.array()[0]
        .charAt(this.array()[0].length - 1)
        .toUpperCase();
    } else if (arrayLength > 1) {
      return this.array()[1].charAt(0).toUpperCase();
    }
    return '';
  });
}
